// drawOla multi-file storage: content write events. Fork-only.
//
// The cloud sync engine has to learn that a draw's content changed. Every
// write path (editor save, Studio rename, breadcrumb rename, import) ends in
// this store, so the store emits and nothing has to be wired through App.tsx.

type DocWrittenListener = (docId: string) => void;

const listeners = new Set<DocWrittenListener>();

/** Subscribe to content writes. Returns the unsubscribe function. */
export function subscribeDocWritten(listener: DocWrittenListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by the store after a write that changed elements, files or name. */
export function emitDocWritten(docId: string): void {
  for (const listener of listeners) {
    try {
      listener(docId);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("[drawOla] docWritten listener failed", e);
    }
  }
}
